import { useEffect, useState } from 'react';
import { bool, func, number, shape, string } from 'prop-types';
import { connect } from 'react-redux';
import { Button } from '@fff-web/fff-ui-shared';
import { events, trackRefillsCanceled } from '../../../../utils/analytics';
import CancelSubscriptionConfirmation from '../CancelSubscriptionConfirmation/CancelSubscriptionConfirmation';
import DetailProduct from '../DetailProduct';
import SubscriptionCancelled from '../SubscriptionCancelled/SubscriptionCancelled';
import * as styles from './MobileDetailProduct.module.scss';

const MobileDetailProduct = ({
  subscription,
  backAction,
  isMobile,
  user,
  subscriptionsQuantity,
  isRefillOnly,
}) => {
  const [cancelling, setCancelling] = useState(false);
  const [subscriptionCancelled, setSubscriptionCancelled] = useState(false);

  const onCancelAction = () => {
    setCancelling(true);
    trackRefillsCanceled(user, null, subscription, events.START_CANCEL);
  };
  const onNeverMind = () => setCancelling(false);
  const onSubscriptionCancelled = () => {
    setSubscriptionCancelled(true);
    trackRefillsCanceled(user, null, subscription, events.CONFIRM_CANCEL);
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, [subscriptionCancelled, cancelling]);

  return (
    <div data-testid="mobile-product-modal" className={styles.container}>
      {!subscriptionCancelled && (
        <div className={styles.buttonWrapper}>
          <Button onClick={backAction}>
            <i className={styles.icon} />
            &nbsp;Back to My Subscriptions
          </Button>
        </div>
      )}
      {!cancelling && <DetailProduct subscription={subscription} onCancelAction={onCancelAction} />}
      {cancelling && !subscriptionCancelled && (
        <CancelSubscriptionConfirmation
          subscriptionUuid={subscription.productId}
          cadenceType={subscription.cadenceType}
          onNeverMind={onNeverMind}
          onSubscriptionCancelled={onSubscriptionCancelled}
          isLastRefillProduct={subscriptionsQuantity === 1}
          isRefillOnly={isRefillOnly}
        />
      )}
      {subscriptionCancelled && (
        <SubscriptionCancelled
          onReturn={backAction}
          isMobile={isMobile}
          isLastRefillProduct={subscriptionsQuantity === 0}
          nextRenewalDate={subscription && subscription.nextRenewalDate}
          isRefillOnly={isRefillOnly}
        />
      )}
    </div>
  );
};

MobileDetailProduct.propTypes = {
  subscription: shape({
    productId: string,
    cadenceType: string,
    brand: string,
    name: string,
    quantity: number,
    nextRenewalDate: string,
  }).isRequired,
  backAction: func.isRequired,
  isMobile: bool.isRequired,
  user: shape({}).isRequired,
  subscriptionsQuantity: number.isRequired,
  isRefillOnly: bool.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user,
  isMobile: state.view.isMobile,
});

export default connect(mapStateToProps)(MobileDetailProduct);
